import { authStore } from "@/store/auth"

import {
  clearError,
  forgotPassword,
  getUserInfo,
  login,
  logout,
  markUserAsOnboardingCompleted,
} from "../actions/auth-actions"
import { AuthState } from "../types"

export function useAuth(): AuthState {
  const state = authStore()

  return {
    ...state,
    login,
    forgotPassword,
    logout,
    getUserInfo,
    markUserAsOnboardingCompleted,
    clearError,
  }
}
